<template>
    <v-card color="rgba(170,170,170,0.4)" class="" height="380" width="100%" style="overflow-y: auto">
        <v-card-title>
            <!-- {{titulos.dados.nome}} -->
        </v-card-title>
        <v-card-subtitle>
            <!-- {{titulos.dados.email}}<br />
            {{titulos.dados.grauAtual}}º grau - {{titulos.dados.claAtual}} -->
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text>
            <v-data-table hide-default-footer fixed-header :items="this.acessos" :headers="fields" :items-per-page="10">
                 <template v-slot:item.ativo="{ item }">
                    <v-simple-checkbox v-model="item.ativo"></v-simple-checkbox>
                </template>
                <!--<template v-slot:item.actions="{ item }">
                    <v-btn text color="primary" @click="editar(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn :disabled="item.cla == 1" text color="primary" @click="excluir(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template> -->
            </v-data-table>
        </v-card-text>
    </v-card>    
</template>
<script>
import { mapState } from 'vuex'

export default {
    props:['acessos'],
    computed:{
        ...mapState(['listaPerfis'])
    },
    data(){
        return{
            fields:[
                {text: "Código", value: 'id_perfil'},
                {text: 'Nome', value: 'nome'},
                {text: 'Ativo', value: 'ativo'}
            ]
        }
    },
    methods:{

    },

    created(){
        
        
    }
}
</script>
<style scoped>

</style>